import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import styles from './index.module.scss'
import { getNotifications, readNotifications } from '@/service'
import noticeImg from '@images/home/notice@2x.png'
import { getToken } from '@/utils/auth'
const Index = () => {
  console.log('ooo000pppp')
  const [open, setOpen] = useState(false)
  const [notice, setNotice] = useState({ header: '', message: '' })
  const showModal = () => {
    setOpen(true)
  }
  const handleCancel = () => {
    setOpen(false)
  }
  const getData = async () => {
    const res = await getNotifications()
    let obj = res ? res?.data?.items?.find((val) => !val.status) : undefined
    if (obj) {
      setNotice(obj)
      showModal()
      readNotifications([obj.id], {})
    }
  }
  useEffect(() => {
    if (getToken()) {
      getData()
    }
  }, [])
  return (
    <div>
      {open ? (
        <div className={styles.notice + ' flex items-center justify-center'} onClick={handleCancel}>
          <div
            className={styles.box}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className={styles.top}>
              <Image src={noticeImg}></Image>
              <div
                className={styles.close + ' rounded-full flex justify-center items-center'}
                onClick={handleCancel}
              >
                <i className="iconfont icon-a-55guanbi-da text-[#fff] "></i>
              </div>
              <div className={styles.title}>{notice?.header}</div>
              <div className={styles.des}>{notice.message}</div>
              <div className={styles.btn} onClick={handleCancel}>
                Got it
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}
export default Index
